<template>
  <div>
    <div class="second"
         v-if="nextContent.length">

      <span :class="[ite.name != '暂无数据'&& ite.name !='正在加载...'  ? (index == ind?'change':'title') : 'first']"
            v-for="(ite,ind) in nextContent"
            :key="ind"
            @click.prevent.stop="openWin(ite)"
            v-show="ite.name&&ite.name.indexOf(inputCons) > -1">
        <a href="javascript:;"
           :title="ite.name">{{ite.name}}</a>
      </span>
    </div>
    <!-- <infinite :nextContent="flowNavList" v-if="flowNavList.length"></infinite> -->
  </div>
</template>
<script>
import Bus from '../bus.js';
export default {
  name: 'infinite',
  props: {
    nextContent: Array,
    inputCons: String
  },
  data () {
    return {
      index: -1,
      flowNavList: [],
      clickInd: -1,
    }
  },
  watch: {
    'nextContent': function (val, newVal) {
      if (val != newVal) {
        this.flowNavList = [];
        this.index = -1
      }
    }
  },
  //跨级触发方法
  inject: ["getId"],
  methods: {
    // showNexts(sub, type,ind){
    //   Bus.$emit('changeFloorContent', sub);
    //   this.index = ind;
    //   var appid = type == 'mainNav' ? sub.appId : this.getQuery('appId')
    //   // this.$http
    //   //   .get(
    //   //     "/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorNavList.json",
    //   //     {
    //   //       appId: appid,
    //   //       flowId: sub.id
    //   //     }
    //   //   )
    //   //   .then(res => {
    //   //     if (res.state == 1) {
    //   //       this.getId(res.data.blockArr);
    //   //       this.flowNavList = [...res.data.subNavArr];
    //   //     }
    //   //   });
    //   this.$http
    //     .get(
    //       "/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowAndBlockByFlowId.json",
    //       {
    //         appId: appid,
    //         flowId: sub.id || "",
    //         navType: 'subNav',
    //         appIdStr:this.getQuery('appId'),
    //         checkType:sub.orgType
    //       }
    //     )
    //     .then(res => {
    //       if(res.state == 1){
    //         var arrays = res.data.filter((ite)=> ite.flowType == 'flow');
    //         this.flowNavList = arrays;
    //         var array = res.data.filter((ite)=> ite.flowType == 'block');
    //         res.data.forEach(element => {
    //           if(element.flowType == 'flow' && element.dataArr.length){
    //             array.push(...element.dataArr);
    //           }
    //         });
    //         this.getId(this.handleFilterBlock(array));
    //       }else{
    //         this.flowNavList = [];
    //       }
    //     })
    // },
    //更多以及收起处理
    // handleFilterBlock (list) {
    //   var allboxWid = 2100;
    //   let fwid = 0;
    //   let start = 0;
    //   list.map((three, ind) => {
    //     fwid += three.name.length * 14 + 28;
    //     if (fwid < allboxWid) {
    //       three.isMore = false;
    //     } else {
    //       if (start == 0) {
    //         start = ind;
    //       }
    //       three.isMore = true;
    //     }
    //     return three;
    //   });
    //   if (start != 0) {
    //     (list.splice(start, 0, { name: '更多', flowType: 'switch', show: true }), list.push({ name: '收起', flowType: 'switch', show: false }))
    //   }
    //   return list;
    // },
    //搜索结束
    openWin (nav) {
      if (nav.wzUrl || nav.pageUrl) {
        // window.location.href = nav.wzUrl || nav.pageUrl;
        this.open(nav.wzUrl || nav.pageUrl,'_self',nav.name);
      } else {
        this.$notify({
          position: 'top-right',
          title: '提示',
          message: '该流程暂无外展平台',
          type: 'warning',
          offset: wH
        });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.second {
  // border-bottom: 1px dashed #ddd;
  margin-bottom: 5px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.second > span:hover {
  background-color: #daeeff;
}
.second .title {
  // padding: 0 16px;
  // width: calc(20% - 32px);
  display: inline-block;
  line-height: 30px;
  height: 30px;
  // background: url("../assets/image/images/index_arrow_bottom.png") no-repeat 90% 50%;
}
.second .change {
  // padding: 0 16px;
  // width: calc(20% - 32px);
  display: inline-block;
  line-height: 30px;
  height: 30px;
  // background: #daeeff url("../assets/image/images/index_arrow_right.png") no-repeat 90% 50%;
}
.second .first {
  // padding: 0 16px;
  // width: calc(20% - 32px);
  display: inline-block;
  line-height: 30px;
  height: 30px;
}
.second .title a,
.second .change a,
.second .first a {
  font-size: 12px;
  color: #333333;
  font-size: 14px;
  max-width: 121px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/infinite.vue